<template>
  <div class="l-content-inner">
    <!-- 로그인 & 회원가입 -->
    <div class="p-member-wrap type-member-login">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">
          BRIGHT COLOR, SMART WORLD
          <b class="color-primary">NOROO PAINT PRO</b>
        </h1>
        <p class="c-text-level2">
          본 서비스는 페인트 프로에 가입된 노루페인트 특약점 회원만 사용하실 수
          있습니다.
        </p>
      </div>

      <div class="c-hgroup is-mo">
        <h1 class="logo">
          <span class="sr-only">NOROO</span>
        </h1>
      </div>

      <div class="login-box">
        <div class="login-field">
          <div class="c-text-tabs">
            <ul>
              <li class="tab-item">
                <!-- D: 활성화클래스 is-active, aria-selected 추가 -->
                <a
                  href="#tab1-1"
                  :class="
                    formType === 'USER_ID'
                      ? 'tab-anchor is-active'
                      : 'tab-anchor'
                  "
                  role="tab"
                  :aria-selected="formType === 'USER_ID' ? true : false"
                  @click.prevent="() => (formType = 'USER_ID')"
                >
                  아이디
                </a>
              </li>
              <li class="tab-item">
                <a
                  href="#tab1-2"
                  :class="
                    formType === 'BUSI_NO'
                      ? 'tab-anchor is-active'
                      : 'tab-anchor'
                  "
                  role="tab"
                  :aria-selected="formType === 'BUSI_NO' ? true : false"
                  @click.prevent="() => (formType = 'BUSI_NO')"
                >
                  사업자번호
                </a>
              </li>
            </ul>
          </div>

          <div class="tab-panel-wrap">
            <!-- tab content: 아이디 -->
            <div
              v-show="formType === 'USER_ID' ? true : false"
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-1"
            >
              <h2 class="sr-only">아이디 탭 내용</h2>
              <form class="login-wrap">
                <div class="c-form-field">
                  <label
                    :class="
                      isUserIdNvl
                        ? 'c-input-label-group is-danger'
                        : 'c-input-label-group'
                    "
                  >
                    <input
                      type="text"
                      required
                      title="아이디"
                      v-model="form.userId"
                      @keyup="() => (userIdTouched = true)"
                      @blur="() => (userIdTouched = true)"
                    />
                    <span class="input-label">아이디</span>
                    <span v-if="isUserIdNvl" class="input-valid">
                      아이디를 입력하여 주세요
                    </span>
                  </label>
                </div>
                <div class="c-form-field">
                  <label
                    :class="
                      isPasswordNvl
                        ? 'c-input-label-group type-password is-danger'
                        : 'c-input-label-group type-password'
                    "
                  >
                    <input
                      v-if="passwordMaskingYn"
                      type="password"
                      required
                      title="비밀번호"
                      v-model="form.password"
                      @keyup="() => (passwordTouched = true)"
                      @blur="() => (passwordTouched = true)"
                    />
                    <input
                      v-if="!passwordMaskingYn"
                      type="text"
                      required
                      title="비밀번호"
                      v-model="form.password"
                      @keyup="() => (passwordTouched = true)"
                      @blur="() => (passwordTouched = true)"
                    />
                    <span class="input-label">비밀번호 확인</span>
                    <span v-if="isPasswordNvl" class="input-valid">
                      비밀번호를 입력해 주세요
                    </span>
                    <span class="input-helper">
                      띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함
                      8~15자
                    </span>
                    <span v-if="passwordFailedYn" class="input-helper">
                      5회 입력 오류시 계정이 잠깁니다.
                    </span>
                    <button
                      type="button"
                      class="c-btn-icon btn-eye"
                      :class="{ 'is-active': !passwordMaskingYn }"
                      @click.prevent="
                        () => (passwordMaskingYn = !passwordMaskingYn)
                      "
                    >
                      <i class="c-icon icon-eye"></i>
                    </button>
                    <button
                      type="button"
                      class="c-btn-icon btn-small-delete"
                      @click.prevent="() => (form.password = '')"
                    >
                      <span class="c-icon icon-small-x"></span>
                    </button>
                  </label>
                </div>
                <div class="flex-box">
                  <div class="c-checkbox">
                    <input
                      type="checkbox"
                      :id="rememberUserIdChkId"
                      v-model="rememberUserIdYn"
                    />
                    <label :for="rememberUserIdChkId">아이디 저장</label>
                  </div>
                  <div class="c-anchor-divi">
                    <a href="#" class="anchor" @click.prevent="goToIdSrch"
                      >아이디 찾기</a
                    >
                    <a href="#" class="anchor" @click.prevent="goToPwdsrch"
                      >비밀번호 찾기</a
                    >
                    <a href="#" class="anchor" @click.prevent="register"
                      >회원가입</a
                    >
                  </div>
                </div>
                <div class="c-btn-area type-full">
                  <button
                    type="submit"
                    class="c-button type-primary"
                    @click.prevent="login"
                    :disabled="
                      Utils.isBlank(form.userId) || Utils.isBlank(form.password)
                    "
                  >
                    <span>로그인</span>
                  </button>
                </div>
              </form>
            </div>

            <!-- tab content: 사업자 번호 -->
            <div
              v-show="formType === 'BUSI_NO' ? true : false"
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-2"
            >
              <h2 class="sr-only">사업자번호 탭 내용</h2>
              <form class="login-wrap">
                <div class="c-form-field">
                  <label
                    :class="
                      isBusiNoNvl
                        ? 'c-input-label-group is-danger'
                        : 'c-input-label-group '
                    "
                  >
                    <input
                      type="text"
                      required
                      title="사업자번호"
                      v-model="form.busiNo"
                      @keyup="() => (busiNoTouched = true)"
                      @blur="() => (busiNoTouched = true)"
                    />
                    <span class="input-label">사업자번호</span>
                    <span v-if="isBusiNoNvl" class="input-valid">
                      사업자번호를 입력하여 주세요
                    </span>
                  </label>
                </div>
                <div class="c-form-field">
                  <label
                    :class="
                      isPasswordNvl
                        ? 'c-input-label-group type-password is-danger'
                        : 'c-input-label-group type-password'
                    "
                  >
                    <input
                      v-if="passwordMaskingYn"
                      type="password"
                      required
                      title="비밀번호"
                      v-model="form.password"
                      @keyup="() => (passwordTouched = true)"
                      @blur="() => (passwordTouched = true)"
                    />
                    <input
                      v-if="!passwordMaskingYn"
                      type="text"
                      required
                      title="비밀번호"
                      v-model="form.password"
                      @keyup="() => (passwordTouched = true)"
                      @blur="() => (passwordTouched = true)"
                    />
                    <span class="input-label">비밀번호</span>
                    <span v-if="isPasswordNvl" class="input-valid">
                      비밀번호를 입력해 주세요
                    </span>
                    <span class="input-helper">
                      띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함
                      8~15자
                    </span>
                    <span v-if="passwordFailedYn" class="input-helper">
                      5회 입력 오류시 계정이 잠깁니다.
                    </span>
                    <button
                      type="button"
                      class="c-btn-icon btn-eye"
                      :class="{ 'is-active': !passwordMaskingYn }"
                      @click.prevent="
                        () => (passwordMaskingYn = !passwordMaskingYn)
                      "
                    >
                      <i class="c-icon icon-eye"></i>
                    </button>
                    <button
                      type="button"
                      class="c-btn-icon btn-small-delete"
                      @click.prevent="() => (form.password = '')"
                    >
                      <span class="c-icon icon-small-x"></span>
                    </button>
                  </label>
                </div>
                <div class="flex-box">
                  <div class="c-checkbox">
                    <input
                      type="checkbox"
                      :id="rememberBusiNoChkId"
                      v-model="rememberBusiNoYn"
                    />
                    <label :for="rememberBusiNoChkId">사업자번호 저장</label>
                  </div>
                  <div class="c-anchor-divi">
                    <a href="#" class="anchor" @click.prevent="goToIdSrch"
                      >아이디 찾기</a
                    >
                    <a href="#" class="anchor" @click.prevent="goToPwdsrch"
                      >비밀번호 찾기</a
                    >
                    <a href="#" class="anchor" @click.prevent="register"
                      >회원가입</a
                    >
                  </div>
                </div>
                <div class="c-btn-area type-full">
                  <button
                    type="submit"
                    class="c-button type-primary"
                    @click.prevent="login"
                    :disabled="
                      Utils.isBlank(form.busiNo) || Utils.isBlank(form.password)
                    "
                  >
                    <span>로그인</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="login-banner">
          <LoginSwiper />
        </div>
      </div>
    </div>

    <!-- D: POPUP - Wrap밖으로 호출 필요 -->
    <PassChangeInstPop v-if="data.isModalVisible" />

    <div v-if="loginFailPopYn" class="alert" data-alert="" tabindex="-1">
      <div class="dialog type-close">
        <div class="dialog-content">
          <div class="text-wrap">
            <p class="text">{{ loginFailMessage }}</p>
          </div>
          <button
            type="button"
            class="dialog-close"
            @click.prevent="closeLoginFailPop"
          >
            <span class="c-icon icon-small-x"></span>
            <span class="sr-only">닫기</span>
          </button>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area type-full">
            <button
              type="button"
              class="c-button type-secondary"
              @click.prevent="goToPwdsrch"
            >
              <span>비밀번호찾기</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click.prevent="goToIdSrch"
            >
              <span>아이디찾기</span>
            </button>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </div>
  </div>
</template>
<script setup name="login_index">
import { ref, reactive, onMounted, computed } from "vue";

import PassChangeInstPop from "@/components/paintpro/base/passChangeInstPop.vue";
import LoginSwiper from "@/components/common/swiper/loginSwiper.vue";
//import Alert from "@/components/common/Alert.vue";
// import IntroFooter from "@/components/common/footer/Intro.vue";
//import { useCookies } from "vue3-cookies";
//import { api } from "@/plugins/api";
import { useRouter } from "vue-router";
import * as store from "@/store";
//import { api } from "../plugins/api";
import * as cmUtil from "@/utils/cmUtil.js";
import Utils from "@/js/utils";
import { v4 as uuidv4 } from "uuid";
import * as cmApi from "@/api/cmApi";

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  isModalVisible: false,
  isDevUserToggle1: false,
  isDevUserToggle2: false,
});

//const url = inject("url_prefix");
const router = useRouter();
const authStore = store.useAuthStore();
const applicationStore = store.useApplicationStore();

const form = ref({
  userId: "",
  busiNo: "",
  password: "",
});

const userIdTouched = ref(false);
const busiNoTouched = ref(false);
const passwordTouched = ref(false);

const passwordMaskingYn = ref(true);
const passwordFailedYn = ref(false);

const formType = ref("USER_ID"); // USER_ID / BUSI_NO

const rememberUserIdYn = ref(false);
const rememberUserIdChkId = uuidv4();

const rememberBusiNoYn = ref(false);
const rememberBusiNoChkId = uuidv4();

const loginFailPopYn = ref(false);
const loginFailMessage = ref("");

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  if ((await cmApi.isLoginApi()).data) {
    // router.replace({
    //   path: "/paintpro/main",
    // });
    location.href = "/paintpro/main";
    return false;
  }
  cmUtil.resetStore();
  if (await pageInitData()) {
    loadRememberUserId();
    loadRememberBusiNo();
  }
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: login_index.pageInitData] `);
    return false;
  }
  return resultCode === 200;
}

const isUserIdNvl = computed(() => {
  return userIdTouched.value && Utils.isBlank(form.value.userId);
});

const isBusiNoNvl = computed(() => {
  return busiNoTouched.value && Utils.isBlank(form.value.busiNo);
});

const isPasswordNvl = computed(() => {
  return passwordTouched.value && Utils.isBlank(form.value.password);
});

const rememberUserId = () => {
  if (rememberUserIdYn.value) {
    localStorage.setItem("REMEMBER_USER_ID", form.value.userId);
  } else {
    localStorage.setItem("REMEMBER_USER_ID", "");
  }
};

const loadRememberUserId = () => {
  const rememberedId = localStorage.getItem("REMEMBER_USER_ID");

  if (Utils.isNotBlank(rememberedId)) {
    form.value.userId = rememberedId;
    rememberUserIdYn.value = true;
  }
};

const rememberBusiNo = () => {
  if (rememberBusiNoYn.value) {
    localStorage.setItem("REMEMBER_BUSI_NO", form.value.busiNo);
  } else {
    localStorage.setItem("REMEMBER_BUSI_NO", "");
  }
};

const loadRememberBusiNo = () => {
  const rememberedBusiNo = localStorage.getItem("REMEMBER_BUSI_NO");

  if (Utils.isNotBlank(rememberedBusiNo)) {
    form.value.busiNo = rememberedBusiNo;
    rememberBusiNoYn.value = true;
  }
};

const login = () => {
  userIdTouched.value = true;
  busiNoTouched.value = true;
  passwordTouched.value = true;

  let loginId = "";
  let password = "";
  let loginGbu = 1;

  if (formType.value === "USER_ID") {
    loginId = form.value.userId; //아이디 로긴
    loginGbu = 1;
    rememberUserId();
  } else if (formType.value === "BUSI_NO") {
    loginId = form.value.busiNo; //사업자로그인
    loginGbu = 2;
    rememberBusiNo();
  }
  password = form.value.password;

  const param = {
    id: loginId.trim(),
    pwd: password.trim(),
    loginGbn: loginGbu,
  };

  let promise = authStore.login(param);

  promise
    .then((result) => {
      if (result.error) {
        if (result.error.status === "209") {
          cmUtil.alert(
            "로그인 정보의 입력 오류가 5회 이상 발생했습니다.​<br />아이디 또는 비밀번호 찾기를 이용하시거나 담당영업사원에게 문의해 주세요."
          );
        } else {
          openLoginFailPop(result.error.message);
        }
        passwordFailedYn.value = true;
      } else {
        //로그인 정보
        authStore.loginInfo(result);
        applicationStore.checkPasswordChangeStatus(result.data);
      }
    })
    .catch((error) => {
      console.log("error======", error);
    });
};

const openLoginFailPop = (message) => {
  loginFailMessage.value = message;
  loginFailPopYn.value = true;
};

const closeLoginFailPop = () => {
  loginFailMessage.value = "";
  loginFailPopYn.value = false;
};

const goToIdSrch = () => {
  router.push("/member/idsrch");
};

const goToPwdsrch = () => {
  router.push("/member/pwdsrch");
};

const register = () => {
  router.push("/member");
};
</script>

<style></style>
